import { render, staticRenderFns } from "./BankMetaDataEdit.vue?vue&type=template&id=3238af82"
import script from "./BankMetaDataEdit.vue?vue&type=script&lang=ts"
export * from "./BankMetaDataEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3238af82')) {
      api.createRecord('3238af82', component.options)
    } else {
      api.reload('3238af82', component.options)
    }
    module.hot.accept("./BankMetaDataEdit.vue?vue&type=template&id=3238af82", function () {
      api.rerender('3238af82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/BankMetaDataEdit.vue"
export default component.exports